import React, { ComponentPropsWithoutRef } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IVoterRegistrationFormErrorProps extends Pick<ComponentPropsWithoutRef<'p'>, 'children'> {
    hasError?: boolean;
    name: string;
    messageId?: string;
}

export const VoterRegistrationFormError = ({
    children,
    name,
    hasError,
    messageId,
}: IVoterRegistrationFormErrorProps) => {
    const intl = useIntl();

    if (!hasError) {
        return null;
    }

    return (
        <div className="grid-row">
            <div>
                <p
                    id={`error--msg__${name}`}
                    data-automation-id={`error--msg__${name}`}
                    data-testid={`error--msg__${name}`}
                    className="shown error--msg"
                >
                    <em>
                        <FontAwesomeIcon icon="exclamation" />
                    </em>
                    {messageId ? intl.formatMessage({ id: messageId }) : children}
                </p>
            </div>
        </div>
    );
};
